<template>
    <div class="modal">
      <div class="modal-background" @click="close"></div>
      <div class="modal-card" style="width: 60%; height: 90%;">
        <header class="modal-card-head">
          <p class="modal-card-title">Sélectionner un avis</p>
          <button class="delete" @click="close"></button>
        </header>
        <section class="modal-card-body">
          <div class="content">
            <h2>Avis</h2>
          </div>
          <ReviewListFilterFlowSimulation @select_review="select_review" />
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="validate_selected_review">Sélectionner</button>
          <button class="button" @click="close">Annuler</button>
        </footer>
      </div>
    </div>
  </template>

  <script>
  import 'bulma-switch';
  import ReviewListFilterFlowSimulation from '@/components/ReviewListFilterFlowSimulation'

  export default {
    name: 'ModalSelectReviewForSimulation',
    props: {
      selected_assistant_uid: String,
    },
    components: {
      ReviewListFilterFlowSimulation
    },
    data() {
      return {
        selected_review_uid: null,
      }
    },
    methods: {
      select_review(uid) {
        console.log('Selecting review', uid)
        this.selected_review_uid = uid
      },
      validate_selected_review() {
        this.$emit("select_review", this.selected_review_uid)
      },
      close() {
        this.$emit('close')
      }
    },
  };
  </script>

  <style scoped>
  </style>